import module from './vue-material-locales'

const VueMaterialLocales = module.default

export {
    VueMaterialLocales as default,
    VueMaterialLocales,
}
